import React from 'react';

const VedLogo = ({ size = 'md', showText = true }) => {
  const sizes = {
    sm: { container: 'w-8 h-8', text: 'text-sm' },
    md: { container: 'w-12 h-12', text: 'text-base' },
    lg: { container: 'w-16 h-16', text: 'text-xl' }
  };

  const { container, text } = sizes[size] || sizes.md;

  return (
    <div className="flex items-center space-x-2">
      <div className={`${container} bg-gradient-to-br from-orange-500 via-orange-600 to-amber-600 rounded-xl flex items-center justify-center relative overflow-hidden shadow-md`}>
        {/* Decorative pattern */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 right-0 w-8 h-8 border-2 border-white rounded-full transform translate-x-3 -translate-y-3"></div>
          <div className="absolute bottom-0 left-0 w-6 h-6 border-2 border-white rounded-full transform -translate-x-2 translate-y-2"></div>
        </div>
        
        {/* Ved text with traditional styling */}
        <span className="text-white font-bold text-xl relative z-10" style={{ fontFamily: 'Georgia, serif' }}>
          वेद
        </span>
      </div>
      
      {showText && (
        <div className="flex flex-col">
          <span className={`${text} font-bold text-gray-800 leading-tight`}>Ved Homestays</span>
          <span className="text-xs text-orange-600 leading-tight">Varanasi</span>
        </div>
      )}
    </div>
  );
};

export default VedLogo;
